// Shared pill-button look for every tab-like switcher in the AI "Add
// Context" modal — the header's Search/Browse switcher, Search's
// Everything/Documents/Matters/Emails/Notes filter, and Browse's
// Documents/Email/Notes switcher — kept in one place so they all render at
// the same size.
const pillButtonStyle = (active) => ({
	fontSize: 13,
	padding: "6px 14px",
	borderRadius: 16,
	border: `1px solid ${
		active ? "var(--lxw-main-500)" : "var(--lw-medium-grey, #ccc)"
	}`,
	background: active ? "var(--lxw-main-500)" : "#fff",
	color: active ? "#fff" : "inherit",
	cursor: "pointer",
	whiteSpace: "nowrap",
});

export default pillButtonStyle;
